import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from '../../../../../utilities/requestClient';

export interface EsAlignmentApiResponse {
  configs: {
    indicator_columns: string[];
    indicators: { [key: string]: any };
    position_columns?: string[];
  };
  data: any[];
}

export function useEsAlignmentData(
  fundId: string | undefined,
  positionDate: string | undefined,
) {
  return useQuery({
    queryKey: ['es-alignment-data', fundId, positionDate],
    queryFn: () => getEsAlignmentData(fundId!, positionDate!),
    enabled: !!fundId && !!positionDate,
  });
}

export const getEsAlignmentData = async (
  fundId: string,
  positionDate: string,
): Promise<EsAlignmentApiResponse> => {
  const response = await AxiosInstance.get(
    `butler_es_alignment/${fundId}/${positionDate}`,
  );
  return response.data;
};
